module.exports = __webpack_public_path__ + "img/icon-ai.5a0f6261.svg";